
import { useStoryblokBridge } from "@storyblok/nuxt-2"
import storyblokMeta from "@/mixins/storyblokMeta"
import storyblokService from "@/services/storyblok.service"
import { defineComponent } from "@nuxtjs/composition-api"

/** Bypassing old region code for new storyblok (v2) implementation
 * This is a single landingpage
 */
export default defineComponent({
    name: "lernen-vor-ort-muhldorf",
    meta: {
        toolbar: {
            hidden: true,
        },
        footer: {
            showPowered: true,
        },
    },
    mixins: [storyblokMeta],
    async asyncData({ route, error }) {
        const slug = "lernen-vor-ort-muhldorf-speeddating"
        const isEditingMode = route.query?._storyblok !== undefined
        const version = isEditingMode ? "draft" : "published"
        const story = await storyblokService
            .getStory(`region/v2/${slug}`, version)
            .catch(() =>
                error({
                    statusCode: 404,
                    message: "Inhalt der Region wurde nicht gefunden.",
                })
            )
        const channelSlug = story?.content?.channel ?? slug
        return { story, channelSlug }
    },
    provide() {
        return {
            channelSlug: this.channelSlug,
        }
    },
    mounted() {
        if (this.story?.id && this.$route.query?._storyblok !== undefined) {
            useStoryblokBridge(
                this.story.id,
                (evStory) => (this.story = evStory)
            )
        }
    },
})
